module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "Perfect-Center"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("It is not normal behavior to kill and mutilate, in multiples, to satisfy an inner dark lust.")])]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_c('span', {
    staticClass: "Bold"
  }, [_vm._v("This book is based on one simple question posed to over 70 of America’s most prolific Serial Killers:")]), _vm._v(" "), _c('span', {
    staticClass: "Bold-Italic"
  }, [_vm._v("Why did you kill?")]), _vm._v(" "), _c('span', {
    staticClass: "Bold"
  }, [_vm._v("Read the response from hand-written letters, court testimony, interviews, and interrogation statements that will give you, the Reader, an eye-opening insight into the mind of these monsters that walked among us.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8000a044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Foreword1.vue
// module id = 72
// module chunks = 0